<template>
  <Toast
    group="default"
    position="bottom-left"
    style="z-index: 1007"
  >
    <template #icon>
      <font-awesome-icon
        icon="fa-regular fa-circle-info"
        class="mt-[2px] text-base"
      />
    </template>
  </Toast>
</template>

<script setup lang="ts">
import Toast from 'primevue/toast'
</script>
